import React from "react";
import TireSizeVariantCardClient from "./TireSizeVariantCard.client";
import { selectDeliveryDate } from "@helpers/deliveryDateSelector";

interface TireSizeVariantCardProps {
  title: string;
  fuelType: string;
  transmission: string;
  price: string;
  location: string;
  expressDeliveryDate?: string;
  standardDeliveryDate?: string;
  isExpress?: boolean;
  variantSlug?: string;
  status?: string;
  isLoggedin: boolean;
  makeName?: string;
  modelName?: string;
  pageType?: string;
  cityName?: string;
}

export default function TireSizeVariantCard({
  title,
  fuelType,
  transmission,
  price,
  location,
  expressDeliveryDate,
  standardDeliveryDate,
  isExpress,
  variantSlug,
  status,
  isLoggedin,
  makeName,
  modelName,
  pageType,
  cityName,
}: TireSizeVariantCardProps) {
  const deliveryDate = selectDeliveryDate({
    expressDeliveryDate,
    standardDeliveryDate,
    isExpress,
    isLoggedIn: isLoggedin,
  });

  const isDiscontinued = status === "out_of_production";
  const nonSellable = status === "non_sellable";
  const isSellable = !nonSellable && !isDiscontinued;

  return (
    <TireSizeVariantCardClient
      title={title}
      fuelType={fuelType}
      transmission={transmission}
      price={price}
      location={location}
      deliveryDate={deliveryDate}
      isExpress={isExpress}
      variantSlug={variantSlug}
      isSellable={isSellable}
      isDiscontinued={isDiscontinued}
      nonSellable={nonSellable}
      isLoggedIn={isLoggedin}
      makeName={makeName}
      modelName={modelName}
      pageType={pageType}
      cityName={cityName}
    />
  );
}
